// extracted by mini-css-extract-plugin
module.exports = {"Section":"AlternatePromotionPage-module--Section--2sP2Y","Left":"AlternatePromotionPage-module--Left--3A5k2","Right":"AlternatePromotionPage-module--Right--2nwY3"};